const ActivityTypeEnum = {
  PRE_PAY: 1,
  SLOTTING_FEE: 2,
  CIRCLE_PRE_PAY: 3,
  CONDITION_PAY: 4,
  AGENT_PRE_PAY: 5,
  AGENT_SLOTTING_FEE: 6,
  AGENT_CONDITION_PAY: 7,
};

const ActivityTypeDescEnum = {
  [ActivityTypeEnum.PRE_PAY]: '一次性预付款',
  [ActivityTypeEnum.SLOTTING_FEE]: '进场费',
  [ActivityTypeEnum.CIRCLE_PRE_PAY]: '循环预付款',
  [ActivityTypeEnum.CONDITION_PAY]: '条件付',
  [ActivityTypeEnum.AGENT_PRE_PAY]: '循环预付款',
  [ActivityTypeEnum.AGENT_SLOTTING_FEE]: '进场费',
  [ActivityTypeEnum.AGENT_CONDITION_PAY]: '条件付',
};

function getActivityDesc(activityType) {
  return ActivityTypeDescEnum[activityType] || `未知活动-${activityType}`;
}

const ActivityStatusEnum = {
  1: '执行中',
  2: '终止',
};

function getActivityStatusDesc(status) {
  return ActivityStatusEnum[status] || `未知状态-${status}`;
}
// 活动是否在执行中
function activityIsInProgress(status) {
  return status === 1;
}

const DayGTVFlowTypeEnum = {
  1: '收入',
  2: '退款',
  3: '成本摊销',
};

function getDayGTVFlowDesc(type) {
  return DayGTVFlowTypeEnum[type] || `未知类型-${type}`;
}

const PayStatusEnum = {
  1: '待付款',
  2: '付款成功',
  3: '付款失败',
};

function getPayStatusDesc(status) {
  return PayStatusEnum[status] || `未知状态-${status}`;
}

export {
  ActivityTypeEnum,
  getActivityDesc,
  getActivityStatusDesc,
  activityIsInProgress,
  getDayGTVFlowDesc,
  getPayStatusDesc,
};
